import { css } from "lit";

export const style = css`
	* {
		box-sizing: border-box;
	}

	:host {
		display: flex;
		flex-direction: column;
		width: 100%;
		height: 100%;
		position: relative;
	}

	.body {
		flex: 1;
		overflow: hidden;
		display: block;
		width: 100%;
		height: 100%;
		position: relative;
	}
`;
